export default "__VITE_ASSET__7e55b48d__"